import { useEffect, useRef } from "react";
import {
  extractDataLayerScript,
  runDataLayerScript,
  wasAddToCartJustFired,
} from "@/utils/dataLayer";

export default function DataLayerRuntime({ dataLayer }) {
  const lastScriptRef = useRef("");

  useEffect(() => {
    const script = extractDataLayerScript(dataLayer);
    if (!script || script === lastScriptRef.current) return;

    if (/add_to_cart/.test(script) && wasAddToCartJustFired()) {
      lastScriptRef.current = script;
      return;
    }

    lastScriptRef.current = script;
    runDataLayerScript(script);
  }, [dataLayer]);

  return null;
}
